module.exports = __webpack_public_path__ + "media/nayan_testimonial.445b26c2.mp4";